import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function ELedgerReportScreen() {
  return (
    <PlaceholderScreen
      icon="📒"
      title="E-Ledger Report"
      subtitle="This report shows electronic ledger entries with debit and credit details. This report will be available in a future update."
    />
  )
}
